module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "chtitle",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Growing")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I pressed my face to the car window, sobbing heavily. Ten years old and my mother had just said that my little bit of childhood was nearly gone. If I pinched my brother, if we tussled in the back seat, the last few morsels would disappear. I cried and cried, wanting to eat the sweet kernels of days flagging out behind us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ten years later I banged my head against a wall because I loved my parents too much and didn’t want to move out. How could you tell someone you loved them too much? It sounded ridiculous, like you just didn’t want to get a job. My father called, “What’s going on in there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wouldn’t move out, so my parents did. They left me in the house with their old Danish sofas and the chipped enamel pan my mother heated milk in when I was a baby. A few nights later I was certain I heard a UFO land in the backyard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After you separate, stories have their own lives within your lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For a while I wanted to dial the phone every time something happened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("Now we have a boy with jumbled curly hair who began asking for coffee when he heard that children who drink coffee might not grow. He asked about the word “stunting.” Someone else’s phrases living in my mouth. Isn’t there a tale where you open your mouth and rocks fall out?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The whole world divides itself between four and five. "), _c('i', [_vm._v("Will this happen when I’m four")]), _vm._v("?—means close, soon. I "), _c('i', [_vm._v("won’t do that till I’m five")]), _vm._v("—far away, a mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our grandfathers are standing on the mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My great-grandmother whose letters live in a battered box in my closet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My great-great-uncle John who wrote in 1889, “I feel so alone, not even a story can afford me pleasure.” And the little boys with curly hair dot each slope, deep green pine trees. We breathe each other’s air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This morning a woman in the post office wasn’t sure what day it was. “Ever since I got old I think Friday is Saturday and Saturday is Friday.” She asked my boy, “Are you a girl or a boy?” then said, “Once I had a little boy with curly hair and his daddy cut off his hair and I cried and cried.” She said to me, “Soon you’ll have to share him with the world, with school—it sounds so easy, but it’s not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was buying stamps to stick on big brown envelopes tossed onto the new computerized scale. He was reading signs out loud, “Please Form Line Here”—“Exit Only”—and every word had weight.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-720f48ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Chapter01.vue
// module id = 90
// module chunks = 0